import React, { Component } from 'react';
import Vas from '../Vas';

import { LinkButton } from 'component-lib';

class ResetPasswordSuccess extends Component
{
    constructor(props)
    {
        super(props);
        this.state = {};
    }

    render()
    {
        return ( <div className="LoginContainer">
          <div
            className={"form"}
            style={{ width:'500px' }}>
            <table>
              <thead>
                <tr>
                  <th colSpan={2}><h2>{Vas.Resources.Labels["ResetPasswordSuccess"]}</h2></th>
                </tr>
              </thead>
              <tbody style={{ width:'100%' }}>
                <tr >
                  <td style={{ textAlign:'right' }}>
                    <div  style={{ float: 'right', paddingRight: '0px' }} className={'ConfirmationLabel'}>{Vas.Resources.Labels["LinkLoginFemininum"]}</div>
                  </td>
                  <td style={{ textAlign:'left' }}>
                    <LinkButton
                      Text={Vas.Resources.Menus["Login"]}
                      Id={"LinkLogin"}
                      OnClick={()=>{Vas.GetView("Login");}}
                      Float={'left'} />
                  </td>
                </tr>
              </tbody>
            </table> 
          </div>
        </div>);
    }
}
export default ResetPasswordSuccess;
